<template>
  <div id="dialog-weather">
    <div class="flex justify-center dialog-content" style="padding:1rem;">
      <div class="vs-col candidate-list" @mousedown="updateSelectedIds(master.id)" v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;">
        <vs-chip
          :color="(selectedIds.includes(master.id)) ? '#2d9cdb' : null "
          class="pm-input-key"
        >
          <feather-icon v-if="master.id === '1'"  icon="WindIcon"      svgClasses="h-6 w-6" class="mr-2" />
          <img v-if="master.id === '2' && (selectedIds.includes(master.id))" :src="rainWhiteIcon" class="mr-2 h-6 w-6" />
          <img v-if="master.id === '2' && !(selectedIds.includes(master.id))" :src="rainDarkIcon" class="mr-2 h-6 w-6" />
          <img v-if="master.id === '3' && (selectedIds.includes(master.id))" :src="snowWhiteIcon" class="mr-2 h-6 w-6" />
          <img v-if="master.id === '3' && !(selectedIds.includes(master.id))" :src="snowDarkIcon" class="mr-2 h-6 w-6" />
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedIds: [],
      snowDarkIcon: require(`@/assets/images/icons/port-master/snow_dark.svg`),
      snowWhiteIcon: require(`@/assets/images/icons/port-master/snow_white.svg`),
      rainDarkIcon: require(`@/assets/images/icons/port-master/rain_dark.svg`),
      rainWhiteIcon: require(`@/assets/images/icons/port-master/rain_white.svg`),
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['weather'];
    },
    enableSave() {
      return true; // ( this.selectedIds && this.selectedIds.length > 0 );
    },
  },
  methods: {
    initData() {
      if ( this.valueMap ) {
        this.selectedIds = [this.valueMap.id];
      }
    },
    updateSelectedIds(masterId) {
      if (this.selectedIds.includes(masterId)) {
        this.selectedIds = [] ;
      } else if ( this.selectedIds.length > 0 ) {
        this.selectedIds = [] ;
        this.selectedIds.push(masterId);
      } else {
        this.selectedIds.push(masterId);
      }
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = this.selectedIds.length > 0 ? this.selectedIds[0] : "";
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#dialog-weather {
  .dialog-content {
    flex-wrap: wrap;
  }
  ul li {
    display: inline;
  }
  .input-user-name {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .con-vs-chip {
    border-radius:5px;
    height:2.2rem;
    font-size: 120%;
  }
  .pm-chip-with-border {
    border:2px solid $pm-blue;
  }
  .pm-chip-without-border {
    border:1px solid #828282;
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
  }
  .candidate-list {
    margin: 0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 4rem;
      padding-left: 0.4rem;
    }
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

